import React, { useContext, memo, useCallback } from "react";
import styles from "./ShiftCell.module.scss";
import { ResourcePlannerContext } from "../../views/resourcePlanner/resourceMonitoring/ResourcePlannerContext";

const ShiftCell = memo(({
  dataList,
  customClass,
  handleClick = null,
  ind,
  pointer,
}) => {
  const permissions = localStorage.getItem("permissions");
  const { setDetail, setIsOpenPopover, detail } = useContext(
    ResourcePlannerContext
  );

  const handleCellClick = useCallback((item) => {
    if (
      permissions.includes("User.View") ||
      permissions.includes("Shift.View") ||
      permissions.includes("Leave.View") ||
      permissions.includes("Task.View")
    ) {
      setDetail({
        userIndex: pointer,
        ind: ind,
        shift: { ...item, workingHours: item.workLoad },
      });
      handleClick(true);
    }
    setIsOpenPopover(null);
  }, [permissions, pointer, ind, setDetail, handleClick, setIsOpenPopover]);

  return (
    <div
      className={`${customClass} ${styles.shiftCell_wrapper} ${
        detail?.userIndex === pointer ? styles.selected : styles.unSelected
      }`}
      style={{
        minWidth: "192px",
        width: "192px",
      }}
    >
      {dataList?.map((item, index) => (
        <div
          key={item.id || index}
          className={`${dataList.length > 1 && styles.DualShifts} ${
            styles.shiftCell
          } ${
            item?.timeoff
              ? styles.TimeOff
              : item.workLoad > item.totalHours
              ? styles.OverBooked
              : (item.workLoad / item.totalHours) * 100 > 0
              ? styles.OccupiedHours
              : (item.workLoad / item.totalHours) * 100 === 0
              ? styles.FullyAvailable
              : ""
          }`}
          onClick={() => handleCellClick(item)}
        >
          <div
            className={styles.shiftStatusBar}
            style={{
              width: `${
                item.workLoad > item.totalHours
                  ? "100"
                  : (item.workLoad / item.totalHours) * 100
              }%`,
            }}
          >
            <div className={styles.shiftCell_content}>
              <div className="d-flex align-items-center z-1">
                {item?.shifts && (
                  <span className="text-sm-400 me-1 w-[94px] truncate">
                    {item.shifts} •
                  </span>
                )}
                <div className="d-flex w-[90px] truncate">
                  {!item?.timeoff && (
                    <p className="text-sm-600 ms-1">{item.workLoad} /</p>
                  )}
                  <p className="text-sm-600 ms-1">{item.totalHours} hrs</p>
                </div>
                {!item?.shifts && (
                  <>
                    <span className="text-sm-400 me-1">• Tasks</span>
                    <div className={styles.tasksBadge}>{item.taskCount}</div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
});

ShiftCell.displayName = 'ShiftCell';

export default ShiftCell;
